var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _g, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _g2, _path144, _g3, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPage404UserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 581,
    height: 575,
    viewBox: "0 0 581 575",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M452.361 575H0L50.5814 557.763H502.943L452.361 575Z",
    fill: "#333333"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0187 98.8603C13.9072 141.325 2.26559 212.767 30.5732 242.887C55.6733 269.574 95.1066 245.715 122.293 272.065C159.932 308.538 107.197 376.253 133.71 441.881C161.771 511.325 266.343 548.134 350.032 538.842C466.672 525.891 563.125 421.232 568.531 307.101C573.802 195.08 489.058 120.362 473.043 106.245C344.582 -6.98842 117.762 -0.299944 45.0187 98.8603Z",
    fill: "#EFEFEF",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M333.097 423.275C332.815 422.583 332.312 422.006 331.667 421.632C331.021 421.258 330.27 421.11 329.531 421.21H329.688H329.845H329.957C328.544 420.289 327.153 419.436 325.762 418.606L324.484 417.843L321.478 416.115L320.155 415.374L316.79 413.578L316.027 413.174C314.659 412.501 313.313 411.828 311.967 411.199L310.868 410.706L307.907 409.381L306.584 408.82C305.597 408.394 304.632 408.012 303.645 407.631L302.591 407.204L298.711 405.79L297.903 405.521C296.871 405.162 295.862 404.847 294.853 404.533L293.574 404.129L290.882 403.366L289.716 403.052C288.482 402.715 287.249 402.423 286.015 402.132H285.835L282.359 401.414L281.192 401.189L278.658 400.763L277.491 400.561L274.575 400.179H273.947L270.493 399.842H269.528L267.016 399.685H265.917H263.674V384.109H287.764C291.268 384.115 294.738 383.428 297.976 382.088C301.213 380.747 304.154 378.78 306.629 376.298C307.841 375.086 308.937 373.763 309.904 372.348C310.852 370.928 311.67 369.426 312.349 367.859C313.737 364.57 314.454 361.037 314.457 357.467V254.222C314.454 250.652 313.737 247.119 312.349 243.83C311.67 242.263 310.852 240.761 309.904 239.341C309.41 238.645 308.894 237.949 308.356 237.299C306.508 235.059 304.302 233.14 301.829 231.62C301.021 231.126 300.214 230.677 299.361 230.251C295.746 228.499 291.782 227.586 287.764 227.58H235.187C234.333 227.58 233.479 227.625 232.63 227.715L231.732 227.827C231.194 227.827 230.656 227.962 230.14 228.074L229.041 228.321L227.74 228.657L226.551 229.039L225.429 229.443C225.026 229.623 224.622 229.78 224.218 229.982L223.254 230.431C222.827 230.655 222.424 230.857 222.02 231.104C221.75 231.248 221.488 231.405 221.235 231.575L219.934 232.406L219.373 232.832C216.012 235.303 213.28 238.531 211.398 242.255C209.515 245.979 208.536 250.094 208.539 254.267V357.512C208.539 364.59 211.349 371.377 216.35 376.382C221.352 381.387 228.136 384.198 235.209 384.198H257.012V399.91H256.115H255.15L252.907 400.089H252.077C249.991 400.269 247.972 400.516 245.998 400.807L245.258 400.92L243.015 401.301L242.275 401.414L239.561 401.952L236.712 402.603L236.286 402.715L234.043 403.299L233.482 403.456L231.082 404.129H230.902C229.13 404.668 227.403 405.229 225.766 405.813L225.452 405.925L223.209 406.755H223.074C221.459 407.384 219.911 408.035 218.431 408.686C210.77 411.928 203.592 416.21 197.099 421.412L197.839 421.726C197.021 421.556 196.169 421.696 195.449 422.12C194.729 422.543 194.192 423.22 193.943 424.018C193.693 424.816 193.75 425.679 194.101 426.437C194.453 427.196 195.074 427.797 195.843 428.123C215.592 435.289 236.334 439.34 257.326 440.13V520.482L222.603 528.001C222.112 528.127 221.656 528.362 221.267 528.689C220.879 529.015 220.569 529.424 220.36 529.886L214.349 542.972C212.952 543.114 211.605 543.564 210.403 544.287C209.2 545.011 208.172 545.992 207.392 547.159C206.612 548.326 206.099 549.652 205.89 551.04C205.681 552.429 205.781 553.846 206.183 555.192C206.585 556.537 207.278 557.777 208.214 558.823C209.15 559.87 210.305 560.696 211.598 561.244C212.89 561.792 214.287 562.048 215.689 561.993C217.091 561.938 218.464 561.574 219.709 560.927L220.024 560.748C220.361 560.565 220.684 560.354 220.988 560.119L221.325 559.85C221.794 559.47 222.223 559.041 222.603 558.571L223.074 557.987L223.455 557.359L223.926 556.506C224.022 556.302 224.105 556.092 224.173 555.877C224.312 555.527 224.424 555.167 224.51 554.8L224.644 554.261C224.884 553.106 224.884 551.915 224.644 550.76L224.51 550.221C224.424 549.854 224.312 549.494 224.173 549.144C224.105 548.929 224.022 548.719 223.926 548.515L223.455 547.64L223.074 547.034C222.917 546.81 222.738 546.63 222.581 546.428C222.208 545.972 221.786 545.559 221.325 545.194L220.988 544.902L225.833 534.33L257.505 527.485V554.957C256.302 555.425 255.206 556.133 254.284 557.039C253.363 557.944 252.636 559.028 252.147 560.224C251.658 561.42 251.417 562.703 251.44 563.995C251.463 565.287 251.748 566.561 252.279 567.739C252.809 568.917 253.574 569.974 254.527 570.847C255.479 571.719 256.599 572.389 257.819 572.814C259.038 573.239 260.331 573.412 261.619 573.321C262.908 573.229 264.164 572.877 265.311 572.284L265.625 572.105C265.963 571.922 266.286 571.711 266.59 571.476L266.926 571.207C267.383 570.828 267.804 570.407 268.182 569.95C268.359 569.758 268.524 569.556 268.676 569.344L269.057 568.715L269.528 567.863C269.624 567.659 269.706 567.449 269.775 567.234C269.914 566.884 270.026 566.524 270.111 566.157L270.246 565.618C270.485 564.463 270.485 563.272 270.246 562.117L270.111 561.578C270.026 561.211 269.914 560.851 269.775 560.501C269.706 560.286 269.624 560.076 269.528 559.872L269.057 558.997L268.676 558.391C268.519 558.167 268.339 557.987 268.182 557.785C267.804 557.328 267.383 556.907 266.926 556.528L266.59 556.259C266.286 556.024 265.963 555.813 265.625 555.63L265.311 555.451C264.963 555.264 264.604 555.099 264.235 554.957V526.901L295.884 533.747L300.729 544.318L300.393 544.61C299.943 544.981 299.53 545.395 299.159 545.844C298.976 546.031 298.811 546.234 298.666 546.45C298.523 546.642 298.395 546.845 298.284 547.056C298.11 547.339 297.953 547.631 297.813 547.932C297.718 548.136 297.635 548.346 297.567 548.56C297.428 548.911 297.315 549.271 297.23 549.638C297.175 549.814 297.13 549.994 297.096 550.176C296.856 551.331 296.856 552.523 297.096 553.678C297.13 553.86 297.175 554.04 297.23 554.216C297.315 554.583 297.428 554.943 297.567 555.294C297.635 555.508 297.718 555.718 297.813 555.922C297.953 556.223 298.11 556.515 298.284 556.797C298.395 557.009 298.523 557.212 298.666 557.403C298.81 557.615 298.968 557.817 299.137 558.009C299.521 558.461 299.941 558.882 300.393 559.266L300.729 559.536C301.037 559.766 301.359 559.976 301.694 560.164L302.03 560.344C303.273 560.97 304.638 561.316 306.028 561.358C307.419 561.399 308.802 561.135 310.079 560.583C311.357 560.031 312.497 559.206 313.421 558.165C314.345 557.124 315.03 555.893 315.427 554.559C315.823 553.225 315.923 551.819 315.717 550.443C315.512 549.066 315.008 547.75 314.24 546.59C313.471 545.429 312.458 544.451 311.271 543.725C310.083 542.999 308.752 542.543 307.369 542.388L301.358 529.303C301.153 528.838 300.844 528.426 300.455 528.099C300.066 527.772 299.608 527.539 299.114 527.417L264.392 519.898V439.816H266.276C288.729 439.974 311.006 435.838 331.908 427.629C332.61 427.179 333.12 426.485 333.34 425.68C333.56 424.876 333.473 424.019 333.097 423.275Z",
    fill: "#333333"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M287.832 410.571V366.535",
    stroke: "#222F36",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M224.24 420.94C224.24 420.94 280.766 371.562 357.479 420.94C357.479 420.94 300.954 455.685 224.24 420.94Z",
    fill: "#43D1B7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M224.24 424.531C224.24 424.531 290.86 451.196 357.479 424.531",
    stroke: "#222F36",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M287.832 436.382V521.223V565.977",
    stroke: "#222F36",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M242.297 548.605L250.462 530.829L287.832 522.749",
    stroke: "#222F36",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M242.297 561.533C247.575 561.533 251.853 557.252 251.853 551.972C251.853 546.691 247.575 542.41 242.297 542.41C237.02 542.41 232.742 546.691 232.742 551.972C232.742 557.252 237.02 561.533 242.297 561.533Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M245.617 543.039C243.759 543.693 242.149 544.907 241.011 546.516C239.872 548.124 239.261 550.046 239.261 552.017C239.261 553.988 239.872 555.91 241.011 557.518C242.149 559.126 243.759 560.341 245.617 560.995C247.475 560.341 249.085 559.126 250.223 557.518C251.362 555.91 251.973 553.988 251.973 552.017C251.973 550.046 251.362 548.124 250.223 546.516C249.085 544.907 247.475 543.693 245.617 543.039Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M333.366 548.605L325.224 530.829L287.832 522.749",
    stroke: "#222F36",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M333.366 561.533C338.644 561.533 342.922 557.252 342.922 551.972C342.922 546.691 338.644 542.41 333.366 542.41C328.089 542.41 323.811 546.691 323.811 551.972C323.811 557.252 328.089 561.533 333.366 561.533Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M336.686 543.039C334.828 543.693 333.218 544.907 332.08 546.516C330.941 548.124 330.33 550.046 330.33 552.017C330.33 553.988 330.941 555.91 332.08 557.518C333.218 559.126 334.828 560.341 336.686 560.995C338.544 560.341 340.153 559.126 341.292 557.518C342.431 555.91 343.042 553.988 343.042 552.017C343.042 550.046 342.431 548.124 341.292 546.516C340.153 544.907 338.544 543.693 336.686 543.039Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M287.832 572.845C293.109 572.845 297.387 568.565 297.387 563.284C297.387 558.003 293.109 553.723 287.832 553.723C282.554 553.723 278.276 558.003 278.276 563.284C278.276 568.565 282.554 572.845 287.832 572.845Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M291.151 554.351C289.293 555.005 287.684 556.219 286.545 557.828C285.407 559.436 284.795 561.358 284.795 563.329C284.795 565.3 285.407 567.222 286.545 568.83C287.684 570.438 289.293 571.653 291.151 572.307C293.01 571.653 294.619 570.438 295.758 568.83C296.896 567.222 297.508 565.3 297.508 563.329C297.508 561.358 296.896 559.436 295.758 557.828C294.619 556.219 293.01 555.005 291.151 554.351Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M315.31 226.817H262.664C247.935 226.817 235.994 238.765 235.994 253.504V356.816C235.994 371.555 247.935 383.503 262.664 383.503H315.31C330.039 383.503 341.98 371.555 341.98 356.816V253.504C341.98 238.765 330.039 226.817 315.31 226.817Z",
    fill: "#43D1B7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M536.477 53.3875H395.275V239.341H536.477V53.3875Z",
    fill: "#333333"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M544.193 48.0682H402.991V234.022H544.193V48.0682Z",
    fill: "#D0D7E1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M533.381 56.2605H413.803V226.862H533.381V56.2605Z",
    fill: "#7788E3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M413.803 226.817H533.381V206.168H530.51V211.375H528.11V199.367H520.73V183.072H506.016V211.375H501.081V199.367H486.344V211.375H482.194V199.367H474.837V211.375H471.697V176.384H464.339V211.375H461.177V176.384H453.819V211.375H449.288V199.367H434.574V211.375H430.133V183.072H423.762V171.132H421.295V183.072H415.418V211.375H413.803V226.817Z",
    fill: "#484773"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M526.428 56.2605H413.803V61.3778H526.428V226.862H533.381V61.3778V56.2605H526.428Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M507.115 46.2277H390.296V52.5795H507.115V46.2277Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M507.115 55.3178H390.296V61.6696H507.115V55.3178Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M507.115 64.4078H390.296V70.7596H507.115V64.4078Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M507.115 73.4979H390.296V79.8497H507.115V73.4979Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M507.115 82.588H390.296V88.9398H507.115V82.588Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M507.115 91.678H390.296V98.0298H507.115V91.678Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M507.115 100.768H390.296V107.12H507.115V100.768Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M507.115 109.858H390.296V116.21H507.115V109.858Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M507.115 118.948H390.296V125.3H507.115V118.948Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M507.115 128.038H390.296V134.39H507.115V128.038Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M507.115 137.128H390.296V143.48H507.115V137.128Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M507.115 146.218H390.296V152.57H507.115V146.218Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M507.115 155.308H390.296V161.66H507.115V155.308Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M507.115 164.398H390.296V170.75H507.115V164.398Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M507.115 173.489H390.296V179.84H507.115V173.489Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M548.567 46.2277H510.951V52.5795H548.567V46.2277Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M548.567 55.3178H510.951V61.6696H548.567V55.3178Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M548.567 64.4078H510.951V70.7596H548.567V64.4078Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M548.567 73.4979H510.951V79.8497H548.567V73.4979Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M548.567 82.588H510.951V88.9398H548.567V82.588Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M548.567 91.678H510.951V98.0298H548.567V91.678Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M548.567 100.768H510.951V107.12H548.567V100.768Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M548.567 109.858H510.951V116.21H548.567V109.858Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M548.567 118.948H510.951V125.3H548.567V118.948Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M548.567 128.038H510.951V134.39H548.567V128.038Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M548.567 137.128H510.951V143.48H548.567V137.128Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M548.567 146.218H510.951V152.57H548.567V146.218Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M548.567 155.308H510.951V161.66H548.567V155.308Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M548.567 164.398H510.951V170.75H548.567V164.398Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M548.567 173.489H510.951V179.84H548.567V173.489Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M561.936 38.821H559.693V178.337H561.936V38.821Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M560.814 183.454C563.639 183.454 565.928 181.163 565.928 178.337C565.928 175.51 563.639 173.219 560.814 173.219C557.99 173.219 555.7 175.51 555.7 178.337C555.7 181.163 557.99 183.454 560.814 183.454Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M572.927 42.1877H382.759C381.866 42.1877 381.011 41.833 380.38 41.2016C379.749 40.5702 379.394 39.7139 379.394 38.821C379.394 37.9281 379.749 37.0718 380.38 36.4404C381.011 35.809 381.866 35.4543 382.759 35.4543H572.927C573.819 35.4543 574.675 35.809 575.306 36.4404C575.937 37.0718 576.291 37.9281 576.291 38.821C576.291 39.7139 575.937 40.5702 575.306 41.2016C574.675 41.833 573.819 42.1877 572.927 42.1877Z",
    fill: "#333333"
  })))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M511.265 43.1977H394.445V49.5495H511.265V43.1977Z",
    fill: "#486473"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M511.265 52.2878H394.445V58.6396H511.265V52.2878Z",
    fill: "#486473"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M511.265 61.3778H394.445V67.7296H511.265V61.3778Z",
    fill: "#486473"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M511.265 70.4679H394.445V76.8197H511.265V70.4679Z",
    fill: "#486473"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M511.265 79.558H394.445V85.9098H511.265V79.558Z",
    fill: "#486473"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M511.265 88.648H394.445V94.9998H511.265V88.648Z",
    fill: "#486473"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M511.265 97.7381H394.445V104.09H511.265V97.7381Z",
    fill: "#486473"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M511.265 106.828H394.445V113.18H511.265V106.828Z",
    fill: "#486473"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M511.265 115.918H394.445V122.27H511.265V115.918Z",
    fill: "#486473"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M511.265 125.008H394.445V131.36H511.265V125.008Z",
    fill: "#486473"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M511.265 134.098H394.445V140.45H511.265V134.098Z",
    fill: "#486473"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M511.265 143.188H394.445V149.54H511.265V143.188Z",
    fill: "#486473"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M511.265 152.278H394.445V158.63H511.265V152.278Z",
    fill: "#486473"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M511.265 161.368H394.445V167.72H511.265V161.368Z",
    fill: "#486473"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M511.265 170.459H394.445V176.81H511.265V170.459Z",
    fill: "#486473"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M552.717 43.1977H515.1V49.5495H552.717V43.1977Z",
    fill: "#486473"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M552.717 52.2878H515.1V58.6396H552.717V52.2878Z",
    fill: "#486473"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M552.717 61.3778H515.1V67.7296H552.717V61.3778Z",
    fill: "#486473"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M552.717 70.4679H515.1V76.8197H552.717V70.4679Z",
    fill: "#486473"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M552.717 79.558H515.1V85.9098H552.717V79.558Z",
    fill: "#486473"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M552.717 88.648H515.1V94.9998H552.717V88.648Z",
    fill: "#486473"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M552.717 97.7381H515.1V104.09H552.717V97.7381Z",
    fill: "#486473"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M552.717 106.828H515.1V113.18H552.717V106.828Z",
    fill: "#486473"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M552.717 115.918H515.1V122.27H552.717V115.918Z",
    fill: "#486473"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M552.717 125.008H515.1V131.36H552.717V125.008Z",
    fill: "#486473"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M552.717 134.098H515.1V140.45H552.717V134.098Z",
    fill: "#486473"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M552.717 143.188H515.1V149.54H552.717V143.188Z",
    fill: "#486473"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M552.717 152.278H515.1V158.63H552.717V152.278Z",
    fill: "#486473"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M552.717 161.368H515.1V167.72H552.717V161.368Z",
    fill: "#486473"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M552.717 170.459H515.1V176.81H552.717V170.459Z",
    fill: "#486473"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M566.085 35.791H563.842V175.307H566.085V35.791Z",
    fill: "#486473"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M564.964 180.424C567.788 180.424 570.078 178.133 570.078 175.307C570.078 172.48 567.788 170.189 564.964 170.189C562.139 170.189 559.85 172.48 559.85 175.307C559.85 178.133 562.139 180.424 564.964 180.424Z",
    fill: "#486473"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M577.076 39.1577H386.931C386.038 39.1577 385.183 38.8029 384.552 38.1716C383.921 37.5402 383.566 36.6839 383.566 35.791C383.566 34.8981 383.921 34.0417 384.552 33.4103C385.183 32.779 386.038 32.4243 386.931 32.4243H577.099C577.991 32.4243 578.847 32.779 579.478 33.4103C580.109 34.0417 580.464 34.8981 580.464 35.791C580.464 36.6839 580.109 37.5402 579.478 38.1716C578.847 38.8029 577.991 39.1577 577.099 39.1577H577.076Z",
    fill: "#486473"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M531.789 325.057H62.6492V337.873H531.789V325.057Z",
    fill: "#8D8BE0"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M500.588 337.873H93.8503V354.392H500.588V337.873Z",
    fill: "#484773"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M130.615 354.414H117.111V561.017H130.615V354.414Z",
    fill: "#56558A"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M130.615 354.414H117.111V370.485H130.615V354.414Z",
    fill: "#2A2942"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M481.97 354.414H468.467V561.017H481.97V354.414Z",
    fill: "#56558A"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M481.97 354.414H468.467V370.485H481.97V354.414Z",
    fill: "#2A2942"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M531.789 325.057H62.6492L88.9605 314.396H505.455L531.789 325.057Z",
    fill: "#A06BDB"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M490.202 257.521H470.889V290.694H490.202V257.521Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M480.535 282.278V285.061",
    stroke: "#486473",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M482.082 279.292L484.415 281.604",
    stroke: "#486473",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M478.987 279.292L476.677 281.604",
    stroke: "#486473",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M488.251 259.721H472.841V288.562H488.251V259.721Z",
    stroke: "#A06BDB",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M472.841 274.108H488.251",
    stroke: "#A06BDB",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M485.222 267.038H482.71",
    stroke: "#486473",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M470.889 290.694H490.202L470.889 292.086V290.694Z",
    fill: "#333333"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M515.773 257.521H496.46V290.694H515.773V257.521Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M506.083 282.278V285.061",
    stroke: "#486473",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M507.653 279.292L509.964 281.604",
    stroke: "#486473",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M504.558 279.292L502.247 281.604",
    stroke: "#486473",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M513.799 259.721H498.389V288.562H513.799V259.721Z",
    stroke: "#A06BDB",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M498.389 274.108H513.822",
    stroke: "#A06BDB",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M510.771 267.038H508.281",
    stroke: "#486473",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M496.46 290.694H515.751L496.46 292.086V290.694Z",
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M128.753 169.83L128.327 169.561L121.597 165.476C121.987 165.152 122.301 164.748 122.518 164.29C122.735 163.833 122.849 163.334 122.853 162.827C122.852 162.272 122.717 161.724 122.459 161.232C122.201 160.74 121.829 160.317 121.373 159.999V130.193H108.789V3.87477C112.199 3.87477 114.913 3.1341 114.913 2.25876C114.913 1.38342 112.064 0.665192 108.543 0.665192C105.021 0.665192 102.172 1.38342 102.172 2.25876C102.172 3.1341 104.595 3.7401 107.713 3.85232V130.193H97.8431V159.999C97.3873 160.317 97.0147 160.74 96.757 161.232C96.4993 161.724 96.364 162.272 96.3627 162.827C96.3685 163.331 96.4815 163.828 96.6942 164.285C96.9069 164.741 97.2145 165.147 97.5963 165.476L58.2303 189.312H160.874L128.753 169.83Z",
    fill: "#333333"
  }))), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M129.672 148.238V2.28119",
    stroke: "#D4D4D4",
    strokeWidth: 0.48,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M182.362 189.312L143.086 165.476C143.468 165.147 143.775 164.741 143.988 164.285C144.201 163.828 144.314 163.331 144.32 162.827C144.318 162.272 144.183 161.724 143.925 161.232C143.668 160.74 143.295 160.317 142.839 159.999V130.193H119.242V159.999C118.786 160.317 118.414 160.74 118.156 161.232C117.898 161.724 117.763 162.272 117.762 162.827C117.767 163.331 117.88 163.828 118.093 164.285C118.306 164.741 118.613 165.147 118.995 165.476L79.6293 189.312H182.362Z",
    fill: "#D14358"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M150.241 169.83L143.086 165.476C142.461 166.011 141.665 166.306 140.843 166.306H125.612L150.241 169.83Z",
    fill: "black"
  }))), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M136.312 2.25876C136.312 3.15654 133.463 3.87477 129.941 3.87477C126.42 3.87477 123.571 3.15654 123.571 2.25876C123.571 1.36097 126.442 0.665192 129.941 0.665192C133.441 0.665192 136.312 1.38342 136.312 2.25876Z",
    fill: "#D4D4D4"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M412.771 325.057H352.971L368.067 319.872H427.867L412.771 325.057Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M262.059 325.057H154.032L169.128 319.872H277.177L262.059 325.057Z",
    fill: "#333333"
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M421.923 319.895H398.976L394.984 299.515H425.916L421.923 319.895Z",
    fill: "#222F36"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M396.509 307.303L425.332 302.523L425.422 302.006L395.096 300.143L396.509 307.303Z",
    fill: "#333333"
  }))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M428.181 295.901H393.077C391.789 295.901 390.744 296.947 390.744 298.236V300.188C390.744 301.478 391.789 302.523 393.077 302.523H428.181C429.469 302.523 430.514 301.478 430.514 300.188V298.236C430.514 296.947 429.469 295.901 428.181 295.901Z",
    fill: "#222F36"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M369.371 313.839L369.08 319.869L402.15 321.464L402.44 315.434L369.371 313.839Z",
    fill: "#FFB947"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M409.137 318.772L402.139 321.466L402.431 315.428L409.137 318.772Z",
    fill: "#FAD16E"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M366.743 316.124V317.314C366.712 317.948 366.929 318.57 367.347 319.047C367.766 319.525 368.354 319.821 368.986 319.872L369.278 313.835C368.639 313.804 368.014 314.028 367.539 314.457C367.064 314.885 366.778 315.485 366.743 316.124Z",
    fill: "#484773"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M275.45 318.413H172.179L175.588 313.61H285.611L275.45 318.413Z",
    fill: "#5066D9"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M275.45 318.413H238.237V320.635H275.45V318.413Z",
    fill: "#222F36"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M275.45 320.613L285.611 315.832V313.61L275.45 318.413V320.613Z",
    fill: "#222F36"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M268.788 320.613H173.614C171.829 320.613 170.118 319.903 168.856 318.641C167.594 317.378 166.885 315.665 166.885 313.88L148.2 256.825C148.2 255.04 148.909 253.327 150.171 252.064C151.433 250.801 153.145 250.092 154.929 250.092H250.103C251.888 250.092 253.599 250.801 254.861 252.064C256.123 253.327 256.832 255.04 256.832 256.825L275.517 313.88C275.517 315.665 274.808 317.378 273.546 318.641C272.284 319.903 270.573 320.613 268.788 320.613Z",
    fill: "#222F36"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M256.832 256.893C256.832 255.107 256.124 253.394 254.862 252.131C253.6 250.869 251.888 250.159 250.103 250.159H154.929C153.773 250.171 152.639 250.481 151.637 251.059C150.635 251.637 149.799 252.463 149.21 253.459C150.378 252.53 151.822 252.017 153.314 252H248.488C250.273 252 251.985 252.709 253.247 253.972C254.508 255.235 255.217 256.947 255.217 258.733L273.902 315.787C273.896 316.974 273.571 318.137 272.96 319.154C273.756 318.54 274.4 317.751 274.844 316.848C275.287 315.945 275.517 314.953 275.517 313.947L256.832 256.893Z",
    fill: "#5066D9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M225.541 155.196V142.335H214.326V141.37L225.429 113.18H226.663V141.325H229.915L229.714 142.291H226.663V155.196H225.541ZM225.541 126.669C225.541 124.268 225.541 117.444 225.743 115.178C224.689 118.028 218.79 133.313 215.672 141.37H225.609L225.541 126.669Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M247.165 121.956V145.994C247.165 152.234 245.662 155.668 240.548 155.668C235.433 155.668 233.975 150.864 233.975 146.129V121.956C233.975 114.818 236.779 112.664 240.705 112.664C245.617 112.664 247.165 116.816 247.165 121.956ZM235.097 121.821V145.859C235.097 152.593 237.497 154.702 240.548 154.702C243.598 154.702 246.066 153.67 246.066 145.927V121.821C246.066 115.267 243.262 113.651 240.615 113.651C237.542 113.651 235.097 115.335 235.097 121.821Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M262.485 155.196V142.335H251.27V141.37L262.238 113.225H263.562V141.37H266.814L266.612 142.335H263.562V155.196H262.485ZM262.485 126.669C262.485 124.268 262.485 117.444 262.687 115.178C261.655 118.028 255.733 133.313 252.615 141.37H262.552L262.485 126.669Z",
    fill: "#333333"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M212.442 167.474H213.339C214.506 167.474 214.797 168.148 214.797 169.247V169.764C214.797 170.931 214.618 171.829 213.249 171.829H212.666V175.756H212.442V167.474ZM212.666 171.649H213.294C214.438 171.649 214.595 170.886 214.595 169.764V169.292C214.595 168.26 214.371 167.654 213.317 167.654H212.666V171.649Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M218.184 172.366L217.624 175.755H217.422L218.79 167.473H219.059L220.45 175.755H220.248L219.687 172.366H218.184ZM219.642 172.187C219.149 169.179 218.969 168.192 218.925 167.698C218.925 168.326 218.588 169.942 218.229 172.187H219.642Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M226.416 175.756H226.215V174.768C226.035 175.576 225.609 175.845 225.048 175.845C224.487 175.845 223.77 175.441 223.77 173.893V169.224C223.77 167.967 224.218 167.361 225.115 167.361C226.013 167.361 226.372 168.439 226.372 169.247V169.449H226.17V169.202C226.17 168.304 225.99 167.563 225.115 167.563C224.241 167.563 223.971 168.102 223.971 169.269V173.758C223.971 174.858 224.218 175.576 225.048 175.576C225.878 175.576 226.215 174.588 226.215 173.085V171.558H224.914V171.379H226.416V175.756Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M232.159 171.356H230.409V175.553H232.383V175.755H230.252V167.473H232.36V167.653H230.476V171.177H232.159V171.356Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M239.92 175.755V167.473H240.211C240.682 169.067 242.454 174.97 242.454 175.419C242.454 174.117 242.454 173.174 242.454 171.76V167.473H242.679V175.755H242.387C242.006 174.476 240.144 168.147 240.144 167.72C240.144 168.708 240.144 169.965 240.144 171.581V175.755H239.92Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M249.139 169.224V173.893C249.139 175.172 248.802 175.868 247.793 175.868C246.783 175.868 246.469 175.351 246.469 173.915V169.247C246.469 167.72 247.097 167.361 247.815 167.361C248.533 167.361 249.139 167.698 249.139 169.224ZM246.671 169.224V173.713C246.671 174.88 246.94 175.531 247.793 175.531C248.645 175.531 248.937 174.701 248.937 173.803V169.157C248.937 168.057 248.668 167.406 247.793 167.406C246.918 167.406 246.671 168.012 246.671 169.314V169.224Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M253.311 167.653H252.077V167.473H254.746V167.653H253.513V175.755H253.311V167.653Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M262.149 167.473H264.392V167.653H262.44V171.177H264.279V171.379H262.44V175.755H262.238L262.149 167.473Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M270.291 169.224V173.893C270.291 175.172 269.954 175.868 268.967 175.868C267.98 175.868 267.622 175.351 267.622 173.915V169.247C267.622 167.72 268.272 167.361 268.967 167.361C269.663 167.361 270.291 167.698 270.291 169.224ZM267.823 169.224V173.713C267.823 174.88 268.093 175.531 268.967 175.531C269.842 175.531 270.089 174.701 270.089 173.803V169.157C270.089 168.057 269.82 167.406 268.967 167.406C268.115 167.406 267.711 168.012 267.711 169.314L267.823 169.224Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M274.104 167.473V174.027C274.104 174.858 274.261 175.666 275.226 175.666C276.19 175.666 276.325 174.925 276.325 174.005V167.473H276.527V174.027C276.527 175.217 276.213 175.868 275.203 175.868C274.194 175.868 273.902 175.284 273.902 174.095V167.473H274.104Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M280.407 175.755V167.473H280.721C281.192 169.067 282.964 174.97 282.964 175.419C282.964 174.117 282.964 173.174 282.964 171.76V167.473H283.166V175.755H282.875C282.516 174.476 280.632 168.147 280.632 167.72C280.632 168.708 280.632 169.965 280.632 171.581V175.755H280.407Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M287.136 167.473H288.236C289.424 167.473 289.806 168.079 289.806 169.471V173.444C289.806 174.88 289.537 175.688 288.101 175.688H287.249L287.136 167.473ZM287.338 175.554H288.011C288.976 175.554 289.492 175.105 289.492 173.623V169.628C289.492 168.416 289.312 167.653 288.146 167.653H287.338V175.554Z",
    fill: "#333333"
  })))), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M206.676 284.271C208.808 285.651 208.808 288.769 206.676 290.148L189.625 301.179C187.415 302.609 184.5 301.023 184.5 298.391C184.5 297.264 185.071 296.214 186.017 295.603L193.151 290.987C195.892 289.214 195.892 285.205 193.152 283.431L186.016 278.811C185.071 278.199 184.5 277.15 184.5 276.024C184.5 273.392 187.416 271.806 189.625 273.236L206.676 284.271Z",
    stroke: "url(#paint0_linear)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.47 284.271C214.601 285.651 214.601 288.769 212.469 290.148L195.418 301.179C193.208 302.609 190.293 301.023 190.293 298.391C190.293 297.264 190.864 296.214 191.81 295.603L198.944 290.987C201.685 289.214 201.685 285.205 198.945 283.431L191.809 278.811C190.864 278.199 190.293 277.15 190.293 276.024C190.293 273.392 193.209 271.806 195.418 273.236L212.47 284.271Z",
    stroke: "#7788E3"
  }))), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M209.324 284.271C207.192 285.651 207.192 288.769 209.324 290.148L226.375 301.179C228.585 302.609 231.5 301.023 231.5 298.391C231.5 297.264 230.929 296.214 229.983 295.603L222.849 290.987C220.108 289.214 220.108 285.205 222.848 283.431L229.984 278.811C230.929 278.199 231.5 277.15 231.5 276.024C231.5 273.392 228.584 271.806 226.375 273.236L209.324 284.271Z",
    stroke: "url(#paint1_linear)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.53 284.271C201.399 285.651 201.399 288.769 203.531 290.148L220.582 301.179C222.792 302.609 225.707 301.023 225.707 298.391C225.707 297.264 225.136 296.214 224.19 295.603L217.056 290.987C214.315 289.214 214.315 285.205 217.055 283.431L224.191 278.811C225.136 278.199 225.707 277.15 225.707 276.024C225.707 273.392 222.791 271.806 220.582 273.236L203.53 284.271Z",
    stroke: "#7788E3"
  }))), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M406.611 305.017C406.611 305.017 411.978 285.304 404.796 271.079C401.746 265.133 400.72 258.353 401.871 251.758C402.443 248.626 403.303 245.551 404.438 242.573",
    stroke: "#535461",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M399.962 233.595C400.013 235.993 404.52 242.835 404.52 242.835C404.52 242.835 408.731 235.769 408.68 233.372C408.655 232.221 408.172 231.128 407.337 230.335C406.502 229.542 405.384 229.113 404.228 229.143C403.071 229.172 401.973 229.658 401.173 230.493C400.373 231.328 399.937 232.444 399.962 233.595Z",
    fill: "#0D2290"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M393.039 247.063C394.391 249.041 401.92 252.327 401.92 252.327C401.92 252.327 401.62 244.131 400.256 242.155C399.607 241.205 398.604 240.552 397.468 240.34C396.332 240.128 395.156 240.375 394.199 241.026C393.242 241.677 392.582 242.678 392.365 243.811C392.147 244.943 392.389 246.113 393.039 247.063Z",
    fill: "#0D2290"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M393.842 269.752C396.015 270.775 404.198 269.82 404.198 269.82C404.198 269.82 399.774 262.923 397.6 261.897C396.561 261.435 395.38 261.397 394.309 261.793C393.239 262.188 392.365 262.984 391.874 264.011C391.383 265.038 391.315 266.213 391.684 267.286C392.053 268.359 392.829 269.243 393.847 269.75L393.842 269.752Z",
    fill: "black"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M398.332 286.765C400.297 288.143 408.517 288.577 408.517 288.577C408.517 288.577 405.331 281.025 403.367 279.65C402.899 279.323 402.371 279.091 401.812 278.967C401.254 278.844 400.676 278.831 400.111 278.93C399.547 279.029 399.007 279.238 398.523 279.544C398.038 279.851 397.619 280.249 397.288 280.716C396.958 281.183 396.723 281.71 396.596 282.267C396.47 282.824 396.454 283.4 396.551 283.961C396.648 284.523 396.855 285.06 397.161 285.541C397.466 286.022 397.864 286.438 398.332 286.765Z",
    fill: "black"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M411.083 252.558C409.393 254.271 401.383 256.209 401.383 256.209C401.383 256.209 403.183 248.2 404.875 246.484C405.687 245.66 406.794 245.19 407.95 245.178C409.107 245.165 410.219 245.61 411.042 246.416C411.865 247.221 412.332 248.321 412.34 249.473C412.348 250.625 411.896 251.735 411.083 252.558Z",
    fill: "#0D2290"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M416.081 272.523C413.955 273.657 405.742 273.122 405.742 273.122C405.742 273.122 409.86 266.004 411.988 264.869C413.006 264.352 414.186 264.253 415.274 264.592C416.362 264.932 417.271 265.682 417.806 266.684C418.342 267.685 418.461 268.857 418.138 269.949C417.816 271.041 417.077 271.965 416.081 272.523Z",
    fill: "#0D2290"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M418.261 292.602C416.356 294.078 408.164 294.932 408.164 294.932C408.164 294.932 411.02 287.229 412.927 285.756C413.379 285.405 413.897 285.146 414.449 284.994C415.002 284.842 415.578 284.799 416.146 284.869C416.714 284.939 417.262 285.119 417.759 285.4C418.256 285.681 418.692 286.057 419.043 286.507C419.393 286.956 419.65 287.471 419.801 288.02C419.951 288.57 419.991 289.144 419.919 289.71C419.846 290.276 419.662 290.822 419.378 291.319C419.094 291.815 418.714 292.251 418.261 292.602Z",
    fill: "black"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M406.449 304.363C406.449 304.363 419.366 288.47 418.602 272.543C418.237 265.865 420.059 259.239 423.794 253.662C425.587 251.027 427.618 248.561 429.862 246.293",
    stroke: "#535461",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M429.439 236.253C428.511 238.472 429.84 246.559 429.84 246.559C429.84 246.559 436.555 241.785 437.484 239.569C437.932 238.504 437.937 237.307 437.498 236.242C437.06 235.177 436.214 234.331 435.146 233.89C434.079 233.449 432.877 233.449 431.806 233.891C430.735 234.332 429.882 235.178 429.434 236.243L429.439 236.253Z",
    fill: "#43D1B7"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M417.645 245.796C418.08 248.152 423.611 254.214 423.611 254.214C423.611 254.214 426.652 246.591 426.226 244.215C426.017 243.086 425.367 242.087 424.418 241.438C423.469 240.788 422.299 240.541 421.163 240.75C420.028 240.959 419.02 241.608 418.361 242.554C417.701 243.499 417.444 244.665 417.645 245.796Z",
    fill: "#43D1B7"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M409.145 266.903C410.711 268.718 418.567 271.144 418.567 271.144C418.567 271.144 417.334 263.033 415.773 261.228C415.4 260.796 414.946 260.441 414.435 260.185C413.925 259.929 413.368 259.775 412.797 259.734C412.226 259.692 411.652 259.762 411.108 259.941C410.563 260.12 410.059 260.404 409.624 260.777C409.189 261.15 408.831 261.604 408.571 262.113C408.312 262.623 408.155 263.178 408.111 263.747C408.066 264.316 408.135 264.887 408.312 265.429C408.489 265.97 408.772 266.471 409.145 266.903Z",
    fill: "#43D1B7"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M406.319 284.3C407.553 286.356 414.876 290.07 414.876 290.07C414.876 290.07 415.044 281.871 413.807 279.816C413.214 278.829 412.252 278.119 411.13 277.842C410.009 277.565 408.822 277.744 407.829 278.338C406.836 278.933 406.119 279.895 405.836 281.013C405.553 282.131 405.727 283.313 406.319 284.3Z",
    fill: "#43D1B7"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M431.873 258.112C429.632 259.001 421.537 257.542 421.537 257.542C421.537 257.542 426.438 250.934 428.679 250.045C429.212 249.833 429.781 249.729 430.354 249.736C430.926 249.744 431.491 249.864 432.016 250.089C432.541 250.314 433.016 250.64 433.413 251.049C433.811 251.457 434.124 251.94 434.333 252.47C434.543 253 434.646 253.566 434.636 254.136C434.626 254.706 434.503 255.269 434.274 255.793C434.046 256.317 433.716 256.792 433.304 257.189C432.892 257.587 432.406 257.901 431.873 258.112Z",
    fill: "#43D1B7"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M428.309 278.417C425.907 278.598 418.63 274.793 418.63 274.793C418.63 274.793 425.288 269.936 427.688 269.756C428.259 269.713 428.833 269.782 429.376 269.96C429.919 270.138 430.422 270.421 430.854 270.792C431.287 271.164 431.642 271.617 431.898 272.126C432.154 272.635 432.307 273.189 432.348 273.758C432.389 274.327 432.317 274.898 432.136 275.44C431.955 275.982 431.669 276.484 431.294 276.916C430.919 277.349 430.462 277.704 429.95 277.962C429.438 278.219 428.88 278.374 428.309 278.417Z",
    fill: "#43D1B7"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M422.128 297.691C419.79 298.273 411.969 295.749 411.969 295.749C411.969 295.749 417.712 289.847 420.049 289.265C421.172 288.985 422.358 289.16 423.348 289.753C424.337 290.345 425.048 291.305 425.324 292.422C425.6 293.539 425.418 294.722 424.819 295.71C424.221 296.698 423.253 297.41 422.13 297.69L422.128 297.691Z",
    fill: "#43D1B7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M396.351 307L423.914 302.326L424 301.821L395 300L396.351 307Z",
    fill: "#333333"
  }))), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M427.181 295.901H392.077C390.789 295.901 389.744 296.947 389.744 298.236V300.188C389.744 301.478 390.789 302.523 392.077 302.523H427.181C428.469 302.523 429.514 301.478 429.514 300.188V298.236C429.514 296.947 428.469 295.901 427.181 295.901Z",
    fill: "#222F36"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 212.138,
    y1: 285.806,
    x2: 184,
    y2: 285.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7788E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 203.862,
    y1: 285.806,
    x2: 232,
    y2: 285.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7788E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.1379,
    height: 36.4138,
    fill: "white",
    transform: "translate(189.793 269)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.1379,
    height: 36.4138,
    fill: "white",
    transform: "matrix(-1 0 0 1 226.207 269)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage404UserIcon);
export default __webpack_public_path__ + "static/media/page-404-user-icon.f3fd97e7.svg";
export { ForwardRef as ReactComponent };